"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@emotion/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CivicCardLink = _interopRequireDefault(require("./CivicCardLink"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          display: flex;\n          flex-direction: \"row\";\n          @media screen and (max-width: 640px) {\n            flex-direction: column;\n          }\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        text-align: center;\n        margin: 1.5em auto;\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function CivicCardLayoutSideBySide(_ref) {
  var isLoading = _ref.isLoading,
      data = _ref.data,
      cardMeta = _ref.cardMeta;
  return (0, _core.jsx)("div", {
    css: (0, _core.css)(_templateObject())
  }, (0, _core.jsx)("div", {
    css: (0, _core.css)(_templateObject2())
  }, (0, _core.jsx)(cardMeta.visualization, {
    isLoading: isLoading,
    data: data
  }), (0, _core.jsx)(cardMeta.visualization, {
    isLoading: isLoading,
    data: data
  })), (0, _core.jsx)(_CivicCardLink["default"], {
    slug: cardMeta.slug
  }, "Learn more"));
}

CivicCardLayoutSideBySide.propTypes = {
  isLoading: _propTypes["default"].bool,
  data: _propTypes["default"].oneOfType([_propTypes["default"].shape({}), _propTypes["default"].array]),
  cardMeta: _propTypes["default"].shape({})
};
var _default = CivicCardLayoutSideBySide;
exports["default"] = _default;